<template>
  <div class="wrapper">
    <!-- data Table -->
    <div v-if="showPage">
      <CRow>
        <CCol col="12" xl="12">
          <CCard class="p-0">
            <CCardHeader
              class="
                d-flex
                justify-content-between
                align-items-center
                bg-secondary
              "
            >
              <h5 class="text-light m-0 p-0">
                برنامه های تعمیر/نگهداری دوره ای
              </h5>
              <CButton
                color="light"
                @click="
                  addModal = true;
                  modalTitle = 'افزودن تعمیر/نگهداری دوره ای';
                  modalButtonSubmit = 'ثبت';
                  restoreDefult();
                "
                class="mr-1"
              >
                <CIcon name="cil-plus" size="lg" /> افزودن
              </CButton>
            </CCardHeader>
            <CCardBody>
              <div id="app">
                <!-- <link
                  href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
                  rel="stylesheet"
                  integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
                  crossorigin="anonymous"
                /> -->
                <main>
                  <data-table
                    v-bind="parametersTable"
                    @actionTriggered="handleAction"
                  />
                </main>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>

    <!-- create and edit device modal --> 
    <CModal :title="modalTitle" :show.sync="addModal" size="xl"  :close-on-backdrop="false">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation" novalidate>
        <h5 class="text-primary mb-3">اطلاعات تعمیر/نگهداری دوره ای</h5>
        <hr />

        <CRow>
          <CInput
            class="col-sm-12 col-md-6 col-lg-4"
            label="نام"
            required
            v-model="info.name"
            :value="info.name"
          />

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">وضعیت</label>
            <multiselect
              class="needs-validation"
              v-model="info.status"
              :options="StatusList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">سرویس</label>
            <multiselect
              class="needs-validation"
              v-model="info.service"
              :options="serviceList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-4 form-group">
            <label class="typo__label">نوع خدمت</label>
            <multiselect
              class="needs-validation"
              v-model="info.typeService"
              :options="typeServiceList"
              :allow-empty="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              placeholder="انتخاب..."
              label="label"
              track-by="value"
              :disabled="disableMultiselect"
            ></multiselect>
          </div>

          <CInput
            v-if="
              info.typeService.value == '1' || info.typeService.value == '3'
            "
            class="col-sm-12 col-md-6 col-lg-4"
            label="مسافت (Km)"
            required
            v-model="info.distance"
            :value="info.distance"
          />

          <CInput
            v-if="
              info.typeService.value == '2' || info.typeService.value == '3'
            "
            class="col-sm-12 col-md-6 col-lg-4"
            label="زمان (روز)"
            required
            v-model="info.day"
            :value="info.day"
          />

          <CTextarea
            class="mt-2"
            label="توضیحات"
            placeholder="Content..."
            rows="5"
            v-model="info.description"
            :value="info.description"
          />
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          v-if="modalButtonSubmit == 'تایید'"
          @click="addModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />تایید</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          v-if="modalButtonSubmit != 'تایید'"
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <!-- assig Car to group modal -->
    <CModal title="تخصیص دستگاه" :show.sync="assignModal" size="xl">
      <CForm class="needs-validation" novalidate>
        <h5 class="text-primary mb-3">
          تخصیص دستگاه به تعمیر/نگهداری دوره ای
          <span class="text-danger">{{ groupName }}</span>
        </h5>
        <hr />

        <v-multiselect-listbox
          class="col-sm-12 p-3"
          v-model="selectedList"
          :options="optionList"
          :reduce-display-property="(option) => option.label"
          :reduce-value-property="(option) => option.id"
          search-options-placeholder="جستجو..."
          selected-options-placeholder="جستجو..."
          style="direction: ltr; height: '500'"
        ></v-multiselect-listbox>
      </CForm>

      <template #footer>
        <CButton
          @click="assignModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="assignDevicesToDevicesGroup"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />اعمال</CButton
        >
      </template>
    </CModal>

    <!-- Alert modal -->
    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف تعمیر/نگهداری دوره ای'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-if="alertModalTitle == 'حذف تعمیر/نگهداری دوره ای'"
          @click="deletedevicePermission"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </div>
</template>


<script>
import axios from "axios";
import { Values } from "../../../src/commonValues";
import $ from "jquery";
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import Multiselect from "vue-multiselect";
import vMultiselectListbox from "vue-multiselect-listbox";

import {
  LMap,
  LTileLayer,
  LControlLayers,
  LPolygon,
  LPopup,
} from "vue2-leaflet";
import LDrawToolbar from "vue2-leaflet-draw-toolbar";

export default {
  name: "Modals",

  components: {
    VueClockPicker,
    LMap,
    LTileLayer,
    LControlLayers,
    LDrawToolbar,
    LPolygon,
    LPopup,
    Multiselect,
    vMultiselectListbox,
  },

  data() {
    return {
      // this part is for main modal (start)
      addModal: false,
      permissions: [],
      modalTitle: "",
      modalButtonSubmit: "",
      // this part is for main modal (end)

      // this part is for alert modal (start)
      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
      // this part is for alert modal (end)

      // this id use when deleting a row
      periodicServiceId: "",

      assignModal: false,
      optionList: [],
      selectedList: [],
      groupName: "",

      info: {
        id: "",
        name: "",
        status: { label: "", value: "" },
        service: { label: "", value: "" },
        typeService: { label: "کیلومتری", value: "1" },
        description: "",
        distance: null,
        day: null,
      },

      serviceList: [
        // { label: "روغن", value: "1" },
        // { label: "تسمه تایم", value: "2" },
        // { label: "لاستیک", value: "3" },
      ],
      typeServiceList: [
        // { label: "کیلومتری", value: "1" },
        // { label: "زمانی", value: "2" },
        // { label: "هردو", value: "3" },
      ],

      StatusList: [],
      disableMultiselect: false,

      alert: false,
      alertText: "",
      showPage: true,
    };
  },

  computed: {
    parametersTable() {
      return {
        data: this.permissions,
        actionMode: "single",
        columns: [
          {
            key: "rowNumber",
            title: "ردیف",
            sortable: false,
          },
          {
            key: "name",
            title: "نام",
          },
          {
            key: "serviceName",
            title: "سرویس",
          },
          {
            key: "typeOfServiceName",
            title: "نوع خدمت",
          },
          {
            key: "distance",
            title: "مسافت",
          },
          {
            key: "periodDuration",
            title: "زمان",
          },
        ],
        actions: ["view", "edit", "delete", "assignCar"],
      };
    },
  },

  mounted() {
    this.refreshTable();

    this.getServicesList();

    this.getServicesTypeList();

    // get status list value from server
    axios
      .get(Values.serverIp + "Constant/GetActiveSelectList")
      .then((response) => {
        this.StatusList = response.data;
      });
  },

  methods: {
    getServicesList(){
    axios
        .get(Values.serverIp + "RepairAndBaseService/GetRepairAndBaseServiceSelectList")
        .then((response) => {
          this.serviceList = response.data;
        });        
    },

    getServicesTypeList(){
    axios
        .get(Values.serverIp + "Constant/GetTypeOfServiceSelectList")
        .then((response) => {
          this.typeServiceList = response.data;
        });        
    },
    //********************************************************************* refresh datatable */
    refreshTable() {
      axios
        .get(Values.serverIp + "PeriodicRepairs/PeriodicRepairs")
        .then((response) => {
          this.permissions = response.data.data;
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else if (response.response.status == 401) {
            //token has expired
            // modal unsuccessful edit change
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            delete axios.defaults.headers.common["Authorization"];
          }
        });
    },

    //********************************************************************* datatable edit action */
    viewAction(data) {
      // disable alet
      this.alert = false;
      this.polygonStatus = true;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "PeriodicRepairs/GetPeriodicRepairs",
          JSON.stringify(data.periodicRepairsId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "ویرایش تعمیر/نگهداری دوره ای";
            this.modalButtonSubmit = "تایید";

            // clear all red borders
            $(".form-control").removeAttr("style");

            this.info.id = response.data.periodicRepairsId;
            this.info.name = response.data.name;
            this.setLimitStatusValue(response.data.status);
            this.setServiceValue(response.data.repairAndBaseServicesId);
            this.setTypeServiceValue(response.data.typeOfService);
            
            this.info.description = response.data.description;
            this.info.distance = response.data.distance;
            this.info.day = response.data.periodDuration;
            // make all part to disabled
            $(
              ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
            ).attr("disabled", true);
            this.disableMultiselect = true;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable edit action */
    editAction(data) {
      // disable alet
      this.alert = false;
      this.polygonStatus = true;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "PeriodicRepairs/GetPeriodicRepairs",
          JSON.stringify(data.periodicRepairsId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.addModal = true;
            this.modalTitle = "ویرایش تعمیر/نگهداری دوره ای";
            this.modalButtonSubmit = "اعمال";


            // clear all red borders
            $(".form-control").removeAttr("style");

            // make all part to enabled
            $(
              ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
            ).attr("disabled", false);
            this.disableMultiselect = false;

            this.info.id = response.data.periodicRepairsId;
            this.info.name = response.data.name;
            this.setLimitStatusValue(response.data.status);
            this.setServiceValue(response.data.repairAndBaseServicesId);
            this.setTypeServiceValue(response.data.typeOfService);
            
            this.info.description = response.data.description;
            this.info.distance = response.data.distance;
            this.info.day = response.data.periodDuration;

            
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //********************************************************************* datatable delete action */
    deleteAction(data) {
      (this.alertModal = true),
        (this.alertModalTitle = "حذف تعمیر/نگهداری دوره ای"),
        (this.alertModalText =
          "آیا از حذف تعمیر/نگهداری دوره ای " + data.name + " مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.periodicServiceId = data.periodicRepairsId);
    },

    //********************************************************************* datatable assign action */
    assignAction(data) {
      //console.log(data);
      this.assignModal = true;
      this.groupName = data.name;
      this.periodicServiceId = data.periodicRepairsId;
      this.getdeviceList();
    },

    //********************************************************************* get device list */
    getdeviceList() {
      axios
        .get(Values.serverIp + "device/GetDualBoxMovingDeviceList")
        .then((response) => {
          this.optionList = response.data;
          this.getdeviceSelectedList();
        });
    },

    //********************************************************************* get user selected List */
    getdeviceSelectedList() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "PeriodicRepairs/GetDualBoxSelectedPeriodicRepairs",
          JSON.stringify(this.periodicServiceId),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.selectedList = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //********************************************************************* assign Users To Group */
    assignDevicesToDevicesGroup() {
      axios
        .post(Values.serverIp + "PeriodicRepairs/AssignDevicesToPeriodicRepairs", {
          PeriodicRepairId: this.periodicServiceId,
          devicesId: this.selectedList,
        })
        .then((response) => {
          if (response.status == 200 && response.data == "0") {
            this.assignModal = false;

            // modal successfuly
            this.alertModal = true;
            this.alertModalTitle = "تغییرات";
            this.alertModalText = "تغییرات با موفقیت انجام شد.";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            this.refreshTable();
          } else {
            // modal unsuccessful
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            if (response.data == "1") {
              this.alertModalText =
                "تعمیر/نگهداری دوره ای وجود ندارد یا خطایی در سیستم رخ داده است.";
            } else {
              this.alertModalText = "خطایی در انجام کار رخ داده است.";
            }
            this.alertModalColor = "warning";
            this.alertModalButtonText = "تایید";
          }
        })
        .catch((error) => {
          console.log(error);
          // modal unsuccessful
          this.alertModal = true;
          this.alertModalTitle = "خطایی رخ داده";
          this.alertModalText = "در ثبت اطلاعات خطایی رخ داده است.";
          this.alertModalColor = "warning";
          this.alertModalButtonText = "تایید";
        });
    },

    //********************************************************************* dataTable actions */
    handleAction(actionName, data) {
      if (actionName == "view") {
        this.viewAction(data);
      } else if (actionName == "edit") {
        this.editAction(data);
      } else if (actionName == "delete") {
        this.deleteAction(data);
      } else if (actionName == "assignCar") {
        this.assignAction(data);
      }
    },

    //******************************************************************** edit and create device */
    submitForm() {
       // clear all red borders
      $(".form-control").removeAttr("style");

       // clear all red borders
        $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
          "style"
        );
         $(
        ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
      ).attr("disabled", false);
      this.disableMultiselect = false;
      // console.log(this.info);

      var forms = document.querySelectorAll(".needs-validation");
      let formValid = true;

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          formValid = false;
        }else if (this.info.status.value == "" || this.info.service.value == "" || this.info.typeService.value == "") {
          $(".needs-validation > .multiselect__tags").css(
            "border-color",
            "red"
          );
          formValid = false;
        }
      }

      let api = "";
      if (this.modalButtonSubmit == "اعمال") api = "EditPeriodicRepairs";
      else {
        api = "CreatePeriodicRepairs";
        this.info.id = "";
      }

      if (formValid == true) {
        // console.log(this.info);
        axios
          .post(Values.serverIp + "PeriodicRepairs/" + api, {
            periodicRepairsId: this.info.id,
            name: this.info.name,
            status: JSON.parse(this.info.status.value),
            description: this.info.description,
            repairAndBaseServicesId: this.info.service.value,
            typeOfService: this.info.typeService.value,
            distance: this.info.distance,
            periodDuration: this.info.day,
          })
          .then((response) => {
            if (response.status == 200 && response.data == "0") {
              this.addModal = false;

              // modal successfuly
              (this.alertModal = true),
                (this.alertModalTitle = "تغییرات"),
                (this.alertModalText = "تغییرات با موفقیت انجام شد."),
                (this.alertModalColor = "success"),
                (this.alertModalButtonText = "تایید"),
                this.refreshTable();
            } else {
              // modal unsuccessful edit change
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              if (response.data == "1") {
                this.alertModalText = "خطا در ثبت اطلاعات رخ داده است.";
              } else if (response.data == "2") {
                this.alertModalText = "اطلاعات به درستی وارد نشده است.";
              }
              this.alertModalColor = "warning";
              this.alertModalButtonText = "تایید";
            }
          })
          .catch((error) => {
            debugger;
            console.log(error);
          });
      } else {
        // this.alert = true;
        // this.alertText = "لطفا تمامی موارد الزامی را وارد نمایید.";

        (this.alertModal = true),
              (this.alertModalTitle = "هشدار"),
              (this.alertModalText =
                "لطفا تمامی موارد الزامی را وارد نمایید."),
              (this.alertModalColor = "warning"),
              (this.alertModalButtonText = "تایید");
      }
    },

    //******************************************************************** delete device */
    deletedevicePermission() {
      this.alertModal = false;
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "PeriodicRepairs/DeletePeriodicRepairs",
          JSON.stringify(this.periodicServiceId),
          config
        )
        .then((response) => {
          if (response.status == 200 && response.data == 0) {
            //console.log(response);
            this.alertModal = true;
            this.alertModalTitle = "حذف";
            this.alertModalText =
              "حذف تعمیر/نگهداری دوره ای با موفقیت انجام شد";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            this.refreshTable();
          } else {
            //console.log("in else"),
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام حذف اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.status != 200) {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام حذف اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //******************************************************************** restore all create input defult */
    restoreDefult() {
      // make all part to enabled
      $(
        ".form-check, .form-control-file, .form-control, .clock-picker__input, .weekDaysBtn"
      ).attr("disabled", false);
      this.disableMultiselect = false;

      this.info.id = "";
      this.info.name = "";
      this.info.status = { label: "", value: "" };
      this.info.service = { label: "", value: "" };
      this.info.typeService = { label: "", value: "" };
      this.info.distance = null;
      this.info.day = null;
      this.info.positionArray = "";
      this.info.description = "";
      this.positionArrayEdit = [];
      $(".leaflet-draw-toolbar").show();

      $(
        "#saturday,#sunday,#monday,#tuesday,#wednesday,#thursday,#friday"
      ).removeClass("text-info");
      $("#saturday,#sunday,#monday,#tuesday,#wednesday,#thursday,#friday").attr(
        "value",
        "0"
      );

      // clear all red borders
      $(".form-control").removeAttr("style");

       // clear all red borders
        $(".form-control, .needs-validation > .multiselect__tags").removeAttr(
          "style"
        );

      // disable alet
      this.alert = false;
    },

    //********************************************************************* on edit acttion set device status */
    setLimitStatusValue(data) {
      for (var i = 0; i < this.StatusList.length; i++) {
        if (this.StatusList[i].value == data) {
          this.info.status.label = this.StatusList[i].label;
          this.info.status.value = this.StatusList[i].value;
        }
      }
    },

    //********************************************************************* on edit acttion set device status */
    setTypeServiceValue(data) {
      for (var i = 0; i < this.typeServiceList.length; i++) {
        if (this.typeServiceList[i].value == data) {
          this.info.typeService.label = this.typeServiceList[i].label;
          this.info.typeService.value = this.typeServiceList[i].value;
        }
      }
    },

    //********************************************************************* on edit acttion set device status */
    setServiceValue(data) {
      for (var i = 0; i < this.serviceList.length; i++) {
        if (this.serviceList[i].value == data) {
          this.info.service.label = this.serviceList[i].label;
          this.info.service.value = this.serviceList[i].value;
        }
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css">
.table-wrapper {
  height: 60vh !important;
}

/* time picker style (start) */
.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #00e676;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  direction: ltr;
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  direction: rtl;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 280px;
}

/* add by alireza */
.clock-picker__input {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.clock-picker__dialog-action[type="button"] {
  color: #39f !important;
}
.clock-picker__dialog-header {
  background-color: #39f !important;
}
/* time picker style (end) */

.msl-search-list-input {
  direction: rtl;
}
</style>
